import { z } from 'zod';

/** 空文字・NaN を null に正規化（number 入力 + valueAsNumber 対策） */
function preprocessNullableInt(val: unknown): number | null | undefined {
  if (val === '' || val === null || val === undefined) return null;
  if (typeof val === 'number' && Number.isNaN(val)) return null;
  return val as number;
}

function preprocessOptionalStorageRoomId(val: unknown): number | undefined {
  if (val === '' || val === null || val === undefined) return undefined;
  if (typeof val === 'number' && Number.isNaN(val)) return undefined;
  return val as number;
}

const nullableIntField = z.preprocess(
  preprocessNullableInt,
  z.number().int().min(0).nullable().optional()
);

/** サンプル登録・編集フォームの Zod スキーマ */
export function buildSampleFormSchema(t: (key: string) => string, isEdit: boolean) {
  return z.object({
    name: z.string().min(1, t('sample.name_required')),
    sampleType: z.string().optional(),
    bslLevel: z.string().optional(),
    initialQuantity: nullableIntField,
    remainingQuantity: nullableIntField,
    unit: z.string().max(50).optional(),
    storageDate: z.string().optional().nullable(),
    disposalDate: z.string().optional().nullable(),
    notes: z.string().optional(),
    storageRoomId: isEdit
      ? z.preprocess(
          preprocessOptionalStorageRoomId,
          z.number().int().positive().optional()
        )
      : z.number().int().positive(t('sample.storage_room_required')),
    drawerNumber: nullableIntField,
    caseName: z.string().optional(),
    pathogenOption: z.enum(['included', 'excluded']).optional(),
    pathogenGenus: z.string().optional(),
    pathogenSpecies: z.string().optional(),
    pathogenSubspecies: z.string().optional(),
    pathogenStrain: z.string().optional(),
    pathogenNote: z.string().optional(),
    drawerNote: z.string().optional(),
  });
}

export type SampleFormData = z.infer<ReturnType<typeof buildSampleFormSchema>>;

/** localStorage から復元する追加フィールド（react-hook-form 外） */
export type LastSampleInputData = Partial<SampleFormData> & { sampleCreatedDate?: string };

export function normalizePathogenOption(value: unknown): 'included' | 'excluded' {
  return value === 'excluded' ? 'excluded' : 'included';
}
